var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYahoo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11118_58562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.931152 7.79012H7.79609L11.7935 18.0167L15.8429 7.79012H22.5263L12.4623 32H5.73546L8.49051 25.5848L0.931365 7.79012H0.931152ZM30.3093 15.9615H22.8234L29.4675 0L36.9261 0.000318884L30.3093 15.9615ZM24.7843 17.4892C27.0812 17.4892 28.9431 19.3512 28.9431 21.6476C28.9431 23.9442 27.0812 25.8062 24.7843 25.8062C22.4877 25.8062 20.6262 23.9442 20.6262 21.6476C20.6262 19.3512 22.488 17.4892 24.7843 17.4892Z",
    fill: "#5F01D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11118_58562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.995,
    height: 32,
    fill: "white",
    transform: "translate(0.931152)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahoo);
export default __webpack_public_path__ + "static/media/yahoo.2e9407b704a0fedd57d01c9252d67004.svg";
export { ForwardRef as ReactComponent };